import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { HttpContext, HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { LoadingBarService } from '../services/loading-bar.service';

/** Set on a request to keep it out of the global loading bar (polls, background refreshes). */
export const SKIP_LOADING_BAR = new HttpContextToken<boolean>(() => false);

/** Convenience for `http.get(url, { context: skipLoadingBar() })`. */
export const skipLoadingBar = (context: HttpContext = new HttpContext()): HttpContext =>
  context.set(SKIP_LOADING_BAR, true);

/** Requests the user never waits on - they should not move the bar. */
const silentUrls = ['/assets/i18n/'];

export const loadingBarInterceptor: HttpInterceptorFn = (req, next) => {
  const skip = req.context.get(SKIP_LOADING_BAR) || silentUrls.some(url => req.url.includes(url));
  if (skip) return next(req);

  const loadingBarService = inject(LoadingBarService);
  loadingBarService.show();
  return next(req).pipe(
    finalize(() => {
      loadingBarService.hide();
    })
  );
}
